module.exports = __webpack_public_path__ + "img/9.4692b30.webp";